require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-101-your-introduction-to-a-tech-career.json") })
        }
      }, "path---blog-code-101-your-introduction-to-a-tech-career");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-101-your-introduction-to-a-tech-career!./.cache/json/blog-code-101-your-introduction-to-a-tech-career.json
// module id = 765
// module chunks = 231608221292675